module.exports = __webpack_public_path__ + "static/img/app.11162463.svg";